import React from 'react';

import { IIconProps } from 'ui/CircleIconButton';
import { theme } from '../../../../../tailwind.config';

export const CrmActivityTitle: React.FC<IIconProps> = React.memo(
  ({ fill = theme.colors['gray-40'], background = theme.colors['white'] }) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25 4.5H15.75V6L2.25 6.0075V4.5ZM15.75 8.2575L2.25 8.25V9.75H15.75V8.2575ZM2.25 12H11.25V13.5H2.25V12Z"
        fill={fill}
      />
    </svg>
  )
);
